import * as React from 'react';

import Lottie from 'react-lottie';

import Helmet from 'react-helmet';

import {List} from '@common/typescript/objects/List';
const arrowIcon = require('@app/images/arrow_circle.svg');
import PetMemorialBlock from '@app/components/UI/PetMemorialBlock/PetMemorialBlock';
import {rest} from '@app/components/Api';
import PetMemorialModalForm from '@app/components/UI/PetMemorialModal/PetMemorialModalForm';
import {StatesListItem} from '@app/objects/StatesListItem';
import {ListOption} from '@app/objects/SidebarProps';
import {MemorialsRes} from '@app/objects/PetMemorial';
import {Veterinarian} from '@app/objects/Veterinarian';
import {transformStateList, transformVetList} from '@app/components/LocalCommon/Utils/transformList';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

import '@app/scss/components/petMemorialHead.scss';
import PetMemorialIcon from '@app/components/Pages/PetMemorial/PetMemorialIcon';

const lottieCandle = require('@app/content/animation/Lottie_Candle.json');
const lottieFloat = require('@app/content/animation/Lottie_Float.json');

const PetMemorial: React.FC = () => {

	const [resMemorials, setResMemorials] = React.useState<MemorialsRes[]>([]);
	const [modalFormVisible, setModalFormVisible] = React.useState<boolean>(false);
	const [stateList, setStateList] = React.useState<StatesListItem[]>([]);
	const stateListOptions: ListOption[] = [];
	const [vetFieldValue, setVetFieldValue] = React.useState<string>('');
	const [vetIdList, setVetIdList] = React.useState<Veterinarian[]>([]);
	const vetListOptions: ListOption[] = [];
	const [totalCount, setTotalCount] = React.useState<number>(0);
	const [sent, setSent] = React.useState<boolean>(false);
	const [stateSelected, setStateSelected] = React.useState<string>('');
	const [currentMemorialId, setCurrentMemorialId] = React.useState<number>(0);

	const initCardsCount = 12;

	const defaultOptions = {
		loop: false,
		autoplay: true,
		animationData: lottieCandle,
	};

	const defaultOptionsFloat = {
		loop: true,
		autoplay: true,
		animationData: lottieFloat,
	};

	const calcCardSpan = () => {
		const cardsText = document.querySelectorAll('.pet-memorial-body__content-card');

		cardsText.forEach((item, index) => {
			// @ts-ignore
			const textLength = item.firstChild.nextSibling.firstChild.textContent.length;

			if (textLength <= 160) {
				item.classList.add('ht3');
			}
			if (textLength > 160 && textLength <= 300) {
				item.classList.add('ht4');
			}
			if (textLength > 300 && textLength <= 400) {
				item.classList.add('ht5');
			}
			if (textLength > 400 && textLength <= 500) {
				item.classList.add('ht6');
			}
			if (textLength > 500 && textLength <= 560) {
				item.classList.add('ht7');
			}
			if (textLength > 560) {
				item.classList.add('ht8');
			}
		});
	};

	const loadMemorials = (petName: string, ownerName: string, reload: boolean) => {
		const offset = reload ? 0 : resMemorials.length;

		rest.get<List<MemorialsRes>>(`v1/memorials/?offset=${offset}&count=${initCardsCount}&owner=${ownerName}&pet=${petName}`)
			.then((res) => {
				if (reload) {
					setResMemorials(res.list);
				} else {
					setResMemorials(prev => prev && [...prev, ...res.list]);
				}
				setTotalCount(res.count);
			})
			.then(() => calcCardSpan());
	};

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
	}, []);

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states').then(res => setStateList(res.list));
	}, []);

	React.useEffect(() => {
		const timeout = setTimeout(() => {
			rest.get<List<Veterinarian>>(`v1/veterinarians/?name=${vetFieldValue}`).then((res) => {
				const vetIdListSorted = res.list.sort((a, b) => a.firstName > b.firstName ? 1 : -1);
				setVetIdList(vetIdListSorted);
			});
		}, 500);

		return () => clearTimeout(timeout);
	}, [vetFieldValue]);

	transformStateList(stateList, stateListOptions);
	transformVetList(vetIdList, vetListOptions);
	return(
		<>
		<Helmet
			title={'Pet Memorials | Lap of Love'}
		/>
		<div id="pet-memorial">
			<div className="pet-memorial-head">
				<div className="pet-memorial-head__wrapper">
					<Lottie
						options={defaultOptionsFloat}
						height={600}
						width={1400}
					/>
					<div className="pet-memorial-head-content">
						<header className="pet-memorial-head__header">
							<h1>
								In Loving Memory
							</h1>
							<h6>
								Remembering the pets who have crossed the rainbow bridge and the paw prints they've forever left on our hearts.
							</h6>
							<button className="btn btn-primary" onClick = {() => {
								setSent(false);
								setModalFormVisible(true);
							}}>
								Create a memorial for your pet
							</button>

						</header>
						{
							resMemorials
								.filter(item => item.images?.length && item.images[0].split('.').length > 1)
								.slice(0, 8)
								.map((item, index) => (
									<PetMemorialIcon item={item} index={index} setCurrentMemorialId={setCurrentMemorialId} key={`pet-memorial-${index}`}/>
								))
						}
					</div>
					<div className="pet-memorial-head__header-more">
						<span>Scroll for memorials</span>
						<img
							src={arrowIcon}
							alt="Arrow"
						/>
					</div>
				</div>
				<Lottie
					options={defaultOptions}
					height={330}
					width={330}
				/>
			</div>
			<PetMemorialBlock
				resMemorials={resMemorials}
				stateListOptions={stateListOptions}
				totalCount={totalCount}
				loadMemorials={loadMemorials}
				currentMemorialId={currentMemorialId}
			/>
			<PetMemorialModalForm
				modalVisible={modalFormVisible}
				setModalVisible = {setModalFormVisible}
				stateListOptions={stateListOptions}
				vetListOptions={vetListOptions}
				setVetFieldValue={setVetFieldValue}
				sent={sent}
				setSent={setSent}
				setStateSelected={setStateSelected}
			/>
		</div>
		</>
	);
};

export default PetMemorial;